export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"property":"og:title","content":"Shambhala User Portal"},{"property":"og:description","content":"Manage your orders for Shambhala Music Festival"},{"property":"og:type","content":"website"},{"property":"og:image","content":"https://portal.shambhalamusicfestival.com/images/active/meta-og-image.jpg"},{"property":"og:url","content":"https://portal.shambhalamusicfestival.com"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/images/active/favicon.ico"},{"rel":"preload","type":"image/gif","href":"/images/active/loader.gif","as":"image"},{"rel":"preload","type":"image/webp","href":"/images/active/default_product_image.webp","as":"image"}],"style":[],"script":[],"noscript":[],"title":"Shambhala Music Festival - User Portal","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"